import styled from 'styled-components';
import { Link } from 'react-router-dom';
import media from 'styled-media-query';
import { MDBContainer } from 'mdbreact';

import { Card } from 'components/Cards/ContentFormCard/styles';
import { Text } from 'components/DescriptionText/styles';
import { Divider as DefaultDivider } from 'components/FormGroup/Divider/styles';

import colors from 'themes/Main';

const { darkBlue, gray03, gray05, white, danger } = colors;

export const Container = styled(MDBContainer)`
  margin: 0 auto;
  max-width: calc(100% - 224px) !important;

  ${media.lessThan('medium')`
    max-width: 100% !important;
  `}
`;

export const ProjectInfos = styled.div`
  margin-top: 50px;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
`;

export const FeaturedText = styled(Text)`
  text-transform: uppercase;

  span {
    display: inline-block;
    font-size: 18px;
    color: ${gray03};
    font-weight: 400;
    margin-left: 8px;
  }
`;

export const Divider = styled(DefaultDivider)`
  margin-top: 32px;

  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -4px;
    width: 100%;
    height: 1px;
    background-color: ${gray05};
  }
`;

export const Form = styled.form``;

export const CoordinatorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-top: 16px;
  padding: 8px 16px;
  background-color: rgba(0, 0, 0, 0.02);
  border-radius: 4px;

  > button {
    margin: 16px 0 32px;
  }
`;

export const CoordinatorBlock = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 16px;
  margin: 16px 0;
  border-radius: 4px;

  &.error {
    border: 1px solid ${danger};
    border-bottom: 1px solid ${danger};
  }

  &:not(.error) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }
`;

export const RemoveCoordinator = styled.button.attrs({
  type: 'button',
})`
  align-self: flex-end;
  width: fit-content;
  margin-top: 16px;
  background-color: transparent;
  border: 0;
  outline: 0;
  font-size: 14px;
  color: ${danger};
  transition: opacity 0.3s ease-in-out;

  svg {
    margin-right: 8px;
  }

  &:hover {
    opacity: 0.6;
  }

  &:disabled {
    opacity: 0.3;
  }
`;

export const FlexRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const Buttons = styled.div`
  margin: 32px 0;

  button:nth-child(2) {
    margin-left: 16px;
  }
`;

export const Employee = styled(Card)`
  &.isOld {
    opacity: 0.5;
    box-shadow: none;
  }

  > div {
    margin-top: 4px;
  }
`;

export const EmployeeInfos = styled.div`
  flex: 1;
`;

export const Search = styled.div`
  margin-bottom: 32px;
`;

export const EmployeeActions = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  button {
    cursor: pointer;
    background: transparent;
    border: 0;
    padding: 8px;

    &:hover {
      opacity: 0.6;
    }

    &:last-child {
      margin-top: 16px;
    }
  }
`;

export const AllocateProfessionals = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  margin: 32px 0;
`;

export const AllocateButton = styled(Link)`
  min-width: 140px;
  width: auto;
  padding: 10px 20px;
  border-radius: 100px !important;
  border: 0;
  background-color: ${darkBlue};
  box-shadow: 0px 1px 3px rgba(0, 169, 255, 0.2),
    0px 2px 2px rgba(0, 169, 255, 0.12), 0px 0px 2px rgba(0, 169, 255, 0.14);
  transition: all 0.2s ease-in;
  color: ${white};
  font-size: 14px;
  line-height: 100%;
  text-transform: uppercase;
  font-weight: 700;

  &:hover {
    opacity: 0.8;
    color: ${white};
  }
`;

export const Loader = styled.div`
  z-index: 50;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100vh;
  background-color: rgba(255, 255, 255, 0.8);
`;
